import { Accordion, Dropdown, Modal } from "react-bootstrap";
import { useAppContext } from "../../../context/app-context";
import "./messageModal.css";
import {
  BsSearch,
  BsChevronLeft,
  BsChevronRight,
  BsFillTrashFill,
  BsArrowRight,
  BsArrowLeft,
  BsPlusLg,
} from "react-icons/bs";
// import { messagesData } from "../../../utils/constants";
import { useEffect, useMemo, useState } from "react";
import NewMessageModal from "./newMessage/NewMessageModal";
import useDisclosure from "../../../hooks/use-disclosure";
import useData from "../../../hooks/use-data";
import { PaginatedApiResponseType } from "../../../types/common";
import { toast } from "react-toastify";
import useMutateData from "../../../hooks/use-mutate-data";
import LabelManager from "./labelManager/LabelManager";
import CustomToggle from "../../custom-toggle/CustomToggle";
import MessageContent from "./messageContent/MessageContent";
import moment from "moment";
import CustomButton from "../../custom-button/CustomButton";

function MessagesModal() {
  const [showMessages, setShowMessages] = useState(true);
  const { isMessagesModalOpen, hideMessagesModal, user, userProfilePic } =
    useAppContext();
  const { show, onHide, onShow } = useDisclosure();
  const [messages, setMessages] = useState<string[]>([]);
  const [selectedMessages, setSelectedMessages] = useState<any>([]);
  const [messageDetails, setMessagesDetails] = useState<any>();
  const [action, setAction] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showLabelManager, setShowLabelManager] = useState(false);
  // const [labelId, setLabelId] = useState("");

  const params = useMemo(
    () => ({
      params: {
        search: searchQuery,
        email: user?.email,
      },
    }),
    [searchQuery, messages, user?.email]
  );

  const { data, refetch } = useData<PaginatedApiResponseType<any[]>>(
    `https://api-dashboard.nautilusassure.io/v1/ws/msg`,
    {
      options: params,
      onError: () => {
        toast("Somthing went wrong", {
          type: "error",
        });
      },
    }
  );

  const { mutate: insertLabeledMessages } = useMutateData(
    `https://api-dashboard.nautilusassure.io/v1/ws/msg`,
    {
      method: "POST",
      onSuccess: () => {
        toast("Created successfully", {
          type: "success",
        });
        refetch();
        setSelectedMessages([]);
      },
      onError: () => {
        toast("Somthing went wrong", {
          type: "error",
          toastId: "add-product",
        });
      },
    }
  );

  const { mutate: updateLabeledMessages } = useMutateData(
    `https://api-dashboard.nautilusassure.io/v1/ws/msg/${selectedId}`,
    {
      method: "PUT",
      onSuccess: () => {
        toast("Label updated successfully", {
          type: "success",
        });
        refetch();
        setSelectedId("");
        setSelectedMessages([]);
      },
      onError: () => {
        toast("Somthing went wrong", {
          type: "error",
          toastId: "add-product",
        });
        setSelectedId("");
        setSelectedMessages([]);
      },
    }
  );

  useEffect(() => {
    if (messageDetails && data) {
      const updatedData = data?.data?.find(
        (ele) => messageDetails?._id === ele?._id
      );
      setMessagesDetails(updatedData);
    }
  }, [data]);

  const { mutate: isMessageView } = useMutateData(
    `https://api-dashboard.nautilusassure.io/v1/ws/msg/${selectedId}`,
    {
      method: "PUT",
      onSuccess: () => {
        refetch();
        setSelectedId("");
        setSelectedMessages([]);
      },
    }
  );

  const handleCreateLabel = (labelName: string) => {
    // setLabelName("");
    setShowLabelManager(false);
    insertLabeledMessages({
      labelName,
      selectedMessages,
      email: user?.email,
    });
  };

  const handleSelectMessage = (
    event: React.ChangeEvent<HTMLInputElement>,
    message: any
  ) => {
    event.stopPropagation();
    setSelectedMessages((prev: any) => {
      return prev.includes(message)
        ? prev.filter((msg: any) => msg !== message)
        : [...prev, message];
    });
  };

  useEffect(() => {
    if (isMessagesModalOpen) {
      refetch();
    }
  }, [isMessagesModalOpen]);

  useEffect(() => {
    if (!showMessages) {
      setShowMessages(true);
    }
  }, [searchQuery]);

  const { mutate } = useMutateData(
    `https://api-dashboard.nautilusassure.io/v1/ws/msg/${selectedId}`,
    {
      onSuccess: () => {
        toast("Message deleted seccussfully", {
          type: "success",
        });
        refetch();
        setSelectedId("");
      },
      onError: () => {
        toast("Something went wrong", {
          type: "error",
          toastId: "product-delete",
        });
        onHide();
        setSelectedId("");
      },
      method: "DELETE",
    }
  );

  const handleAddClick = (event: React.MouseEvent, method: string, id: any) => {
    event.stopPropagation();
    if (selectedMessages.length > 0) {
      setAction(method);
      setSelectedId(id);
    } else {
      toast("Please select the message to add in to the label", {
        type: "error",
      });
    }
  };

  const handleDeleteClick = (
    event: React.MouseEvent,
    method: string,
    id: any
  ) => {
    event.stopPropagation();
    setAction(method);
    setSelectedId(id);
  };

  useEffect(() => {
    if (selectedId) {
      if (action === "add" && selectedMessages.length > 0) {
        updateLabeledMessages(selectedMessages);
      } else if (action === "delete") {
        mutate();
      } else if (action === "readMessage") {
        isMessageView({ isRead: true });
      }
    }
  }, [selectedId]);

  useEffect(() => {
    if (!isMessagesModalOpen) {
      setSearchQuery("");
      setShowMessages(true);
      setSelectedMessages([]);
    }
  }, [isMessagesModalOpen]);

  const handleOpenMessage = (event: React.MouseEvent, item: any) => {
    event.stopPropagation();
    setShowMessages(false);
    setMessagesDetails(item);
    setAction("readMessage");
    if (!item?.isRead) {
      setSelectedId(item._id);
    }
  };

  return (
    <Modal
      className="modal-xl"
      show={isMessagesModalOpen}
      onHide={hideMessagesModal}
      centered
    >
      <Modal.Header className="messageModal" closeButton>
        <Modal.Title>Messaging System</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-2 messageModal rounded-bottom">
        <div className="d-flex p-0 m-0 gap-2">
          <div className="position-relative w-100">
            <input
              type="text"
              className="searchInput w-100 rounded-4 border-0 pb-2 pt-2"
              placeholder="Search emails..."
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
            <BsSearch className="searchIcon" />
          </div>
          <img
            src={
              userProfilePic?.photo ||
              process.env.PUBLIC_URL + "/assets/icons/profile1.png"
            }
            alt="Profile Image"
            className="profileImg img-fluid"
          />
        </div>
        {showMessages ? (
          <div
            className="row m-0 align-items-center my-2"
            style={{ height: "45px" }}
          >
            <div className="col-10 ps-0">
              <button
                className="primary-button"
                onClick={() => {
                  onShow();
                  setMessagesDetails({});
                }}
              >
                Send Message
              </button>
            </div>
            <div className="col-2 ps-2 paginationNumbers">
              <span>{data?.data?.length}</span>
              <BsChevronLeft />
              <BsChevronRight />
              {selectedMessages.length > 0 ? (
                <Dropdown drop="down" align="end">
                  <Dropdown.Toggle as={CustomToggle}></Dropdown.Toggle>

                  <Dropdown.Menu
                    popperConfig={{ strategy: "fixed" }}
                    renderOnMount={true}
                    className="border border-light shadow"
                  >
                    <Dropdown.Item onClick={() => setShowLabelManager(true)}>
                      Creat New Label
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="message-box">
          <div className="p-2">
            {showMessages ? (
              data?.data && data?.data?.length > 0 ? (
                data?.data?.map((item: any) =>
                  item?.labelName ? (
                    <Accordion
                      key={item._id}
                      className="custom-accordion messages p-0"
                    >
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          <div className="d-flex w-100 align-items-md-center justify-content-between ps-4">
                            <span>{item?.labelName}</span>
                            <div className="d-flex px-3">
                              <CustomButton
                                onClick={(e) =>
                                  handleAddClick(e, "add", item._id)
                                }
                                className="addIcon"
                              >
                                <BsPlusLg className="me-2" /> add
                              </CustomButton>
                              <BsFillTrashFill
                                className="deleteIcon"
                                onClick={(e) =>
                                  handleDeleteClick(e, "delete", item._id)
                                }
                              />
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          {item?.selectedMessages?.map((ele: any) => (
                            <div
                              key={ele._id}
                              className={`d-flex messages p-2 ${
                                ele.isRead ? "" : "message-read"
                              }`}
                            >
                              <div className="fw-bold px-2 ps-4">
                                {user?.email === ele?.sender ? (
                                  <BsArrowRight />
                                ) : (
                                  <BsArrowLeft />
                                )}
                              </div>
                              <div
                                className="d-flex w-100"
                                onClick={(e) => handleOpenMessage(e, ele)}
                              >
                                <div style={{ width: "25%" }}>
                                  {ele?.sender}
                                </div>
                                <div
                                  className="d-flex"
                                  style={{ width: "60%" }}
                                >
                                  <span>{ele?.sub}</span>
                                </div>
                                <div style={{ width: "15%" }}>
                                  {moment(ele?.dateTime).format(
                                    "HH:mm DD/MM/YYYY"
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ) : (
                    <div
                      key={item._id}
                      className={`d-flex align-items-center messages ${
                        item.isRead ? "" : "message-read"
                      }`}
                    >
                      <div className="d-flex align-items-center p-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={`checkbox-${item._id}`}
                          checked={selectedMessages.includes(item)}
                          onChange={(e) => handleSelectMessage(e, item)}
                        />
                        <div className="d-flex align-items-center fw-bold px-2">
                          {user?.email === item?.sender ? (
                            <BsArrowRight />
                          ) : (
                            <BsArrowLeft />
                          )}
                        </div>
                      </div>
                      <div
                        className="d-flex w-100 p-2"
                        onClick={(e) => handleOpenMessage(e, item)}
                      >
                        <div style={{ width: "25%" }}>{item?.sender}</div>
                        <div className="d-flex" style={{ width: "60%" }}>
                          <span>{item?.sub}</span>
                        </div>
                        <div style={{ width: "15%" }}>
                          {moment(item?.dateTime).format("HH:mm DD/MM/YYYY")}
                        </div>
                      </div>
                      <div className="px-3">
                        <BsFillTrashFill
                          className="deleteIcon"
                          onClick={(e) =>
                            handleDeleteClick(e, "delete", item._id)
                          }
                        />
                      </div>
                    </div>
                  )
                )
              ) : (
                <div className="d-flex justify-content-center mt-5">
                  No Messages Found
                </div>
              )
            ) : (
              <MessageContent
                setShowMessages={setShowMessages}
                messageDetails={messageDetails}
                onShow={onShow}
              />
            )}
          </div>
        </div>
        <NewMessageModal
          show={show}
          onHide={onHide}
          setShowMessages={setShowMessages}
          setMessages={setMessages}
          refetch={refetch}
          showMessages={showMessages}
          messageDetails={messageDetails}
        />
        <LabelManager
          show={showLabelManager}
          onHide={() => setShowLabelManager(false)}
          handleCreateLabel={handleCreateLabel}
        />
      </Modal.Body>
    </Modal>
  );
}

export default MessagesModal;
